import { Building2 } from 'lucide-react';

/**
 * Inline subtitle rendered on a ProviderCard when the active scope (Personal
 * or Space) has zero accounts for this provider, but the same provider is
 * connected at the org level and visible to the caller.
 *
 * Org admins see the dedicated Org tab — this hint is for everyone else, so
 * they at least know an org credential exists without granting them any
 * details or action affordance. (Per user requirement, fully read-only.)
 */
interface Props {
  className?: string;
}

export default function OrgAvailabilityHint({ className = '' }: Props) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-xs text-muted-foreground ${className}`}
      title="Your org admin has connected this provider at the org level. Contact them if you need access."
    >
      <Building2 className="h-3 w-3" aria-hidden />
      Also available at org level
    </span>
  );
}
